import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

@Component({
  selector: 'app-testimonials',
  imports: [
    CommonModule
  ],
  templateUrl: './testimonials.component.html',
  styleUrl: './testimonials.component.css'
})
export class TestimonialsComponent {
  tesi: any

  ngOnInit() {
    this.testimonials();
  }

  
  testimonials() {
    this.tesi = [
      {
        img: "../assets/images/all-instructor/testimonial/testi-1.png",
        name: "Ankush",
        text: "I’m happy that I took the SilverZone Mock Tests before my Olympiads. They helped me practise better and sharpen my problem-solving and logical thinking skills. Thanks to these tests, the Olympiad felt a lot easier, and my concepts became much clearer and easier to understand.",
        city: "Haryana",
        class:"t-box1"
      },

       {
        img: "../assets/images/all-instructor/testimonial/testi-2.png",
        name: "Yukti Rana",
        text: "SilverZone helped me see where I stood in my Olympiad preparation. It made the exam format easy to understand and showed me which topics I excelled in and where I needed improvement. Thanks to that, I could focus better, improve my weak areas, and build a strategy that gave me a lot more confidence for the final exam. ",
         city: "Delhi",
          class:"t-box2"
      },
      {
        img: "../assets/images/all-instructor/testimonial/testi-3.png",
        name: "Deepak ",
        text: "SilverZone Mock Tests helped me overcome my challenges while preparing for the Olympiads. They boosted my thinking and problem-solving skills. I saw a significant improvement in my scores, especially in the Science Olympiad. These practice tests not only helped me grow but also played a big part in helping me win. ",
        city: "Haryana",
          class:"t-box3"
      },
      {
        img: "../assets/images/all-instructor/testimonial/testi-4.png",
        name: "Darsh ",
        text: "Earlier, I used to feel nervous about how to face the Olympiad exams. However, SilverZone Mock Tests helped me get accustomed to the exam pattern and challenging questions. They made me more confident and showed me the right way to practise. As a result, my Olympiad journey with SilverZone became much smoother and more focused. ",
        city: "Delhi",
          class:"t-box4"
      },
      {
        img: "../assets/images/all-instructor/testimonial/testi-5.png",
        name: "HARGUN KAUR",
        text: "SilverZone Mock Tests helped me during my Olympiad preparation. The instant results and performance analysis helped me track my progress and stay ahead in the competition. These mock tests also made a big difference in improving my critical thinking and reasoning skills, which helped me perform even better. ",
        city: "Delhi",
          class:"t-box5"
      },
      {
        img: "../assets/images/all-instructor/testimonial/testi-6.png",
        name: "Arhant ",
        text: "I liked solving SilverZone Mock Tests because they were fun and exciting. These tests helped me improve my skills and brought me closer to my dream. While I was preparing, my parents and teachers helped me, and they were both happy to see how much I improved after taking the Mock Tests.",
        city: "Haryana",
          class:"t-box6"
      },
    ];
  }


}
